// @ts-check

import { api } from '@/api'
import { toCamelCase, toSnakeCase } from '@/helpers/formatters'
import * as _ from 'lodash-es'

/**
 * Fetches account transactions based on the given params and pagination data.
 * @param {*} params
 * @param {*} page
 */
export const getAccountTransactions = async (params, page) => {
  const requestBody = { params: { ...params } }

  if (page) {
    requestBody.params = Object.assign(requestBody.params, { page })
  }

  if (_.has(requestBody.params, 'search')) {
    requestBody.params.search = encodeURI(requestBody.params.search)
  }

  return api.get(`account-transactions`, requestBody)
}

export const getFastPrivateWithdrawalStatus = async () => {
  const res = await api.get('settings/fast-withdrawal-status')
  return toCamelCase(res)
}

export const createPrivateWithdrawal = async (payload) =>
  api.post('journals/create-withdrawal', toSnakeCase(payload))

export const createFastWithdrawal = async (payload) =>
  api.post('journals/create-fast-withdrawal', toSnakeCase(payload))

export const canWithdrawMoney = async () => {
  const {
    data: { can_withdraw_money }
  } = await api.get('can-withdraw-money')
  return can_withdraw_money
}
